import { render, staticRenderFns } from "./combineDataList.vue?vue&type=template&id=ac2e2e94&scoped=true"
import script from "./combineDataList.vue?vue&type=script&lang=js"
export * from "./combineDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2e2e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac2e2e94')) {
      api.createRecord('ac2e2e94', component.options)
    } else {
      api.reload('ac2e2e94', component.options)
    }
    module.hot.accept("./combineDataList.vue?vue&type=template&id=ac2e2e94&scoped=true", function () {
      api.rerender('ac2e2e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/resource/combineDataList.vue"
export default component.exports